import { Button, FormControl, MenuItem } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  TableHeader,
  TableHeaderItem,
  TABLE_HEADER_ACTION_SX,
} from 'src/components/TableHeader/TableHeader';
import { ActiveTintSelect } from './ActiveTintSelect.styles';
import { useContactCaptureListController } from '../../controllers';
import { CONTACT_CAPTURE_TYPE_LABELS, CONTACT_CAPTURE_TYPES } from '../../helpers';

type Props = Pick<ReturnType<typeof useContactCaptureListController>,
  'changeSearch' | 'changeStatus' | 'changeType' | 'filter'
>;

export const ContactCaptureListHeader = ({
  changeSearch,
  changeStatus,
  changeType,
  filter,
}: Props) => {
  const navigate = useNavigate();

  return (
    <TableHeader
      searchValue={filter.query}
      searchPlaceholder="Search by name"
      onSearchChange={changeSearch}
      filters={(
        <>
          <TableHeaderItem>
            <FormControl fullWidth size="small">
              <ActiveTintSelect
                aria-label="Filter by type"
                displayEmpty
                active={!!filter.type}
                value={filter.type || ''}
                onChange={event => changeType(event.target.value as 'popup' | 'inline' | '')}
              >
                <MenuItem value="">All types</MenuItem>
                {CONTACT_CAPTURE_TYPES.map(value => (
                  <MenuItem key={value} value={value}>{CONTACT_CAPTURE_TYPE_LABELS[value]}</MenuItem>
                ))}
              </ActiveTintSelect>
            </FormControl>
          </TableHeaderItem>
          <TableHeaderItem>
            <FormControl fullWidth size="small">
              <ActiveTintSelect
                aria-label="Filter by status"
                displayEmpty
                active={!!filter.status}
                value={filter.status || ''}
                onChange={event => changeStatus(event.target.value as 'draft' | 'active' | 'inactive' | '')}
              >
                <MenuItem value="">All statuses</MenuItem>
                <MenuItem value="draft">Draft</MenuItem>
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
              </ActiveTintSelect>
            </FormControl>
          </TableHeaderItem>
        </>
      )}
      actions={(
        <Button
          variant="contained"
          size="small"
          sx={TABLE_HEADER_ACTION_SX}
          onClick={() => navigate('/contact-capture/new')}
        >
          Create Contact Capture
        </Button>
      )}
    />
  );
};

